export enum DaysmartSyncIntervalEnum {
  NONE = 'none',
  TWENTY_FOUR_HOURS = '24_hours',
  FOURTY_EIGHT_HOURS = '48_hours',
  SEVENTY_TWO_HOURS = '72_hours',
}
